import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { BASE_URL, buildCollectionPageSchema, stringifySchema } from "../utils/schema";
import Header from "../component/Header";
import LetsTalk from "../component/LetsTalk";
import Footer from "../component/Footer";
import DiscoverArrow from "../component/icons/DiscoverArrow";

const clientsSchema = buildCollectionPageSchema({
    name: "Abox Agency Clients",
    url: `${BASE_URL}/clients`,
    description:
        "The ecommerce and D2C brands Abox Agency has partnered with across Shopify development, UI/UX design, branding and conversion optimization.",
});

const clientCategories = [
        {
            categoryName: "Healthcare & Wellness",
            clients: [
                {
                    clientHref: '/portfolio/healing-hands',
                    clientImgSrc: '/assets/image/clients/healing_hands.svg',
                    clientImgAlt: 'Healing Hands logo',
                    clientInfoOne: 'Piles, Fissure, Fistula &',
                    clientInfoTwo: 'Constipation Medicines',
                },
                {
                    clientHref: '/portfolio/dr-vaidya',
                    clientImgSrc: '/assets/image/clients/dr_vaidyas.svg',
                    clientImgAlt: 'Dr Vaidyas logo',
                    clientInfoOne: 'Ayurvedic Stamina and',
                    clientInfoTwo: 'Health Supplements',
                },
                {
                    clientHref: '/portfolio/nourysh',
                    clientImgSrc: '/assets/image/clients/nourysh.svg',
                    clientImgAlt: 'Nourysh logo',
                    clientInfoOne: 'Health-Optimized Nutrient',
                    clientInfoTwo: 'Formulas',
                },
                {
                    clientHref: '/portfolio/label/my-herb',
                    clientImgSrc: '/assets/image/clients/myherb.svg',
                    clientImgAlt: 'MyHerb logo',
                    clientInfoOne: 'Pure plant-powered',
                    clientInfoTwo: 'nutrition.',
                },
                {
                    clientHref: '/portfolio/glosense',
                    clientImgSrc: '/assets/image/clients/glosense.svg',
                    clientImgAlt: 'Glosense logo',
                    clientInfoOne: 'Your nutrition partner.',
                },
                {
                    clientHref: 'https://orthovedic.in/',
                    clientImgSrc: '/assets/image/clients/orthovedic.svg',
                    clientImgAlt: 'Orthovedic logo',
                    clientInfoOne: 'Move better, live stronger.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/mia',
                    clientImgSrc: '/assets/image/clients/mia.svg',
                    clientImgAlt: 'Mia logo',
                    clientInfoOne: 'Natural comfort you',
                    clientInfoTwo: 'can trust.',
                },
                {
                    clientHref: '/portfolio/giver-nutritions',
                    clientImgSrc: '/assets/image/clients/giver.svg',
                    clientImgAlt: 'Giver nutritions logo',
                    clientInfoOne: 'Mental Wellness Supplement',
                    clientInfoTwo: 'Innovators',
                },
                {
                    clientHref: '/portfolio/ayurmedix',
                    clientImgSrc: '/assets/image/clients/ayurmedix.svg',
                    clientImgAlt: 'Ayurmedix logo',
                    clientInfoOne: 'Modern Ayurveda.',
                },
                {
                    clientHref: 'https://agrogramproducts.com/',
                    clientImgSrc: '/assets/image/clients/natures_megic.svg',
                    clientImgAlt: 'Natures Magic logo',
                    clientInfoOne: 'Pure by nature.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/westerville',
                    clientImgSrc: '/assets/image/clients/westerville.svg',
                    clientImgAlt: 'Westerville logo',
                    clientInfoOne: 'Comprehensive Dental',
                    clientInfoTwo: 'Care Excellence',
                },
                {
                    clientHref: 'https://vanasparsh.com/',
                    clientImgSrc: '/assets/image/clients/vanasparsh.svg',
                    clientImgAlt: 'Vanasparsh logo',
                    clientInfoOne: 'Nature in its purest form.',
                    target: '_blank',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/swara-organic.svg',
                    clientImgAlt: 'Swara Organic logo',
                    clientInfoOne: 'Pure, naturally preserved.',
                },
                {
                    clientHref: '/portfolio/maadico',
                    clientImgSrc: '/assets/image/clients/maadico.svg',
                    clientImgAlt: 'Maadico logo',
                    clientInfoOne: 'Tradition powered wellness.',
                },
                {
                    clientHref: 'https://www.dag.dental/',
                    clientImgSrc: '/assets/image/clients/dag.svg',
                    clientImgAlt: 'Dantal Associates Group logo',
                    clientInfoOne: 'Where care meets precision.',
                    target: '_blank',
                },
                {
                    clientHref: 'https://herbalpouch.com/',
                    clientImgSrc: '/assets/image/clients/herbal-pouch.svg',
                    clientImgAlt: 'Herbal Pouch logo',
                    clientInfoOne: 'Small drops, big wellness.',
                    target: '_blank',
                },
                {
                    clientHref: 'https://gleeglee.in/',
                    clientImgSrc: '/assets/image/clients/glee_glee.svg',
                    clientImgAlt: 'Glee Glee logo',
                    clientInfoOne: 'Joy, without limits',
                    clientClass: 'big_logo_box',
                    target: '_blank',
                },
                {
                    clientHref: 'https://www.brutalrx.com/',
                    clientImgSrc: '/assets/image/clients/brutal.svg',
                    clientImgAlt: 'BrutalRX logo',
                    clientInfoOne: 'Dominate your biology.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/aumex',
                    clientImgSrc: '/assets/image/clients/aumex.svg',
                    clientImgAlt: 'Aumex logo',
                    clientInfoOne: 'Feminine Wellness and',
                    clientInfoTwo: 'Hygiene Solutions',
                },
                {
                    clientHref: '/portfolio/healthoxide',
                    clientImgSrc: '/assets/image/clients/helthoxide.svg',
                    clientImgAlt: 'Helthoxide logo',
                    clientInfoOne: 'Elevate your health and',
                    clientInfoTwo: 'fitness journey.',
                },
                {
                    clientHref: '/portfolio/mypro',
                    clientImgSrc: '/assets/image/clients/mypro.svg',
                    clientImgAlt: 'MyPro logo',
                    clientInfoOne: 'Premium quality sports nutrition',
                    clientInfoTwo: 'for peak performance',
                },
                {
                    clientHref: '/portfolio/spark-fusion',
                    clientImgSrc: '/assets/image/clients/spark-fusion.svg',
                    clientImgAlt: 'Spark Fusion logo',
                    clientInfoOne: 'Fuel your everyday strength.',
                },
                {
                    clientHref: '/portfolio/weight-manage',
                    clientImgSrc: '/assets/image/clients/weightmanage.svg',
                    clientImgAlt: 'Weight Manage logo',
                    clientInfoOne: 'Health & Wellness',
                    clientInfoTwo: 'through Science',
                },
                {
                    clientHref: '/portfolio/bodyart',
                    clientImgSrc: '/assets/image/clients/body_art.svg',
                    clientImgAlt: 'Body Art logo',
                    clientInfoOne: 'Train smarter, not longer',
                },
                {
                    clientHref: '/portfolio/label/oval',
                    clientImgSrc: '/assets/image/clients/oval.svg',
                    clientImgAlt: 'Oval logo',
                    clientInfoOne: 'Decode your metabolism.',
                },
            ]
        },
        {
            categoryName: "Skin & Beauty Care",
            clients: [
                {
                    clientHref: '/portfolio/label/kayura-effect',
                    clientImgSrc: '/assets/image/clients/kayura.svg',
                    clientImgAlt: 'Kayura logo',
                    clientInfoOne: 'Where Ayurveda meets',
                    clientInfoTwo: 'science.',
                },
                {
                    clientHref: '/portfolio/label/ras-beauty',
                    clientImgSrc: '/assets/image/clients/ras.svg',
                    clientImgAlt: 'RAS Beauty logo',
                    clientInfoOne: 'Science-backed Luxury',
                    clientInfoTwo: 'Skincare',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/within-beauty',
                    clientImgSrc: '/assets/image/clients/within_beauty.svg',
                    clientImgAlt: 'Within Beauty logo',
                    clientInfoOne: 'Ceramide-powered skincare',
                    clientInfoTwo: 'for healthy skin',
                },
                {
                    clientHref: 'https://naturali.co.in/',
                    clientImgSrc: '/assets/image/clients/naturli.svg',
                    clientImgAlt: 'Naturali logo',
                    clientInfoOne: `Natural Hair & Skin Care`,
                    target: '_blank',
                },
                {
                    clientHref: 'https://kasscare.com/',
                    clientImgSrc: '/assets/image/clients/kass.svg',
                    clientImgAlt: 'Kass Care logo',
                    clientInfoOne: 'Skincare that thinks deeper',
                    clientClass: 'big_logo_box',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/bayla',
                    clientImgSrc: '/assets/image/clients/bayla_skin.svg',
                    clientImgAlt: 'Bayla Skin logo',
                    clientInfoOne: `Nature's Science for`,
                    clientInfoTwo: 'Radiant Skin',
                },
                {
                    clientHref: '/portfolio/label/acnex-topical',
                    clientImgSrc: '/assets/image/clients/acnex.svg',
                    clientImgAlt: 'Acnex logo',
                    clientInfoOne: 'Science for acne-free skin.',
                },
                {
                    clientHref: '/portfolio/label/anthi-naturals',
                    clientImgSrc: '/assets/image/clients/anthi.svg',
                    clientImgAlt: 'Anthi Naturals logo',
                    clientInfoOne: 'Stronger hair, naturally.',
                },
                {
                    clientHref: '/portfolio/kutum-ayurveda',
                    clientImgSrc: '/assets/image/clients/kutum.svg',
                    clientImgAlt: 'Kutum Ayurveda logo',
                    clientInfoOne: 'Ayurvedic Beauty and',
                    clientInfoTwo: 'Wellness Products',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/label/moody',
                    clientImgSrc: '/assets/image/clients/moody.svg',
                    clientImgAlt: 'Moody logo',
                    clientInfoOne: 'Made for every skin mood.',
                },
                {
                    clientHref: 'https://kloy.in/',
                    clientImgSrc: '/assets/image/clients/kloy.svg',
                    clientImgAlt: 'Kloy logo',
                    clientInfoOne: 'Hair & Scalp Shampoo Brush:',
                    clientInfoTwo: 'Effective Haircare Tool',
                    target: '_blank',
                },
                {
                    clientHref: 'https://www.kayapalatcare.com/',
                    clientImgSrc: '/assets/image/clients/kayapalat.svg',
                    clientImgAlt: 'Kayapalat logo',
                    clientInfoOne: 'Naturopathy for real change',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/label/molecule',
                    clientImgSrc: '/assets/image/clients/molecule.svg',
                    clientImgAlt: 'Molecule53 logo',
                    clientInfoOne: 'Peptide-powered skin science.',
                },
                {
                    clientHref: 'https://mysree.com/',
                    clientImgSrc: '/assets/image/clients/myshree.svg',
                    clientImgAlt: 'Myshree logo',
                    clientInfoOne: 'Rooted in purity',
                    target: '_blank',
                },
                {
                    clientHref: 'https://www.nolaskinsentials.com/',
                    clientImgSrc: '/assets/image/clients/nola_skin.svg',
                    clientImgAlt: 'Nola Skin logo',
                    clientInfoOne: 'Vegan Skin Essentials',
                    clientClass: 'big_logo_box',
                    target: '_blank',
                },
                {
                    clientHref: 'https://nyratech.in/',
                    clientImgSrc: '/assets/image/clients/nyra.svg',
                    clientImgAlt: 'Nyra logo',
                    clientInfoOne: 'Skincare, but smarter.',
                    target: '_blank',
                },
                {
                    clientHref: 'https://truecolors.world/',
                    clientImgSrc: '/assets/image/clients/otrix-true-colors.svg',
                    clientImgAlt: 'Otrix True Colors logo',
                    clientInfoOne: 'Express your true shade.',
                    target: '_blank',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/nirae-beauty.svg',
                    clientImgAlt: 'Nirae Beauty logo',
                    clientInfoOne: 'Your gateway to K-beauty.',
                },
            ]
        },
        {
            categoryName: "Jewellery",
            clients: [
                {
                    clientHref: '/portfolio/silverfied',
                    clientImgSrc: '/assets/image/clients/silverfied.svg',
                    clientImgAlt: 'Silverfied logo',
                    clientInfoOne: 'Pure silver, pure expression.',
                },
                {
                    clientHref: 'https://lioroi.com/',
                    clientImgSrc: '/assets/image/clients/lioroi.svg',
                    clientImgAlt: 'Lioroi logo',
                    clientInfoOne: 'Where luxury feels personal.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/savani-jewellery',
                    clientImgSrc: '/assets/image/clients/savani.svg',
                    clientImgAlt: 'Savani logo',
                    clientInfoOne: `Fine Diamond`,
                    clientInfoTwo: 'Jewellery',
                },
                {
                    clientHref: '/portfolio/sevpoori',
                    clientImgSrc: '/assets/image/clients/sevpoori.svg',
                    clientImgAlt: 'Sevpoori logo',
                    clientInfoOne: 'Crafted to make you shine.',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/krit.svg',
                    clientImgAlt: 'Krit logo',
                    clientInfoOne: 'Everyday sparkle, effortlessly.',
                },
            ]
        },
        {
            categoryName: "Apparel & Fashion",
            clients: [
                {
                    clientHref: '/portfolio/technosport',
                    clientImgSrc: '/assets/image/clients/technosport.svg',
                    clientImgAlt: 'Technosport logo',
                    clientInfoOne: 'Performance Active',
                    clientInfoTwo: 'Sportswear and Athleisure',
                },
                {
                    clientHref: '/portfolio/uppercase',
                    clientImgSrc: '/assets/image/clients/uppercase.svg',
                    clientImgAlt: 'Uppercase logo',
                    clientInfoOne: 'Eco Friendly Bags',
                },
                {
                    clientHref: '/portfolio/branding/typical',
                    clientImgSrc: '/assets/image/clients/typical.svg',
                    clientImgAlt: 'Typical logo',
                    clientInfoOne: 'Basics, but better.',
                },
                {
                    clientHref: '/portfolio/chaykra',
                    clientImgSrc: '/assets/image/clients/chaykra.svg',
                    clientImgAlt: 'chaYkra logo',
                    clientInfoOne: `Yoga Wears and`,
                    clientInfoTwo: 'Accessories',
                },
                {
                    clientHref: 'https://woxen.in/',
                    clientImgSrc: '/assets/image/clients/woxen.svg',
                    clientImgAlt: 'Woxen logo',
                    clientInfoOne: 'Everyday wear, elevated.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/branding/velora',
                    clientImgSrc: '/assets/image/clients/velora.svg',
                    clientImgAlt: 'Velora logo',
                    clientInfoOne: 'Crafted for timeless presence.',
                },
                {
                    clientHref: '/portfolio/nurdle',
                    clientImgSrc: '/assets/image/clients/nurdle.svg',
                    clientImgAlt: 'Nurdle logo',
                    clientInfoOne: `Fun, Comfortable Kids'`,
                    clientInfoTwo: 'Underwear with Surprises!',
                },
                {
                    clientHref: '/portfolio/maa-and-baby',
                    clientImgSrc: '/assets/image/clients/maa_baby.svg',
                    clientImgAlt: 'Maa and Baby logo',
                    clientInfoOne: 'Baby products for your',
                    clientInfoTwo: 'precious moments.',
                },
                {
                    clientHref: 'https://svarian.com/',
                    clientImgSrc: '/assets/image/clients/svarian.svg',
                    clientImgAlt: 'Svarian logo',
                    clientInfoOne: 'Luxury, redefined with purpose.',
                    target: '_blank',
                },
                {
                    clientHref: 'https://liorabag.com/',
                    clientImgSrc: '/assets/image/clients/liora.svg',
                    clientImgAlt: 'Liora logo',
                    clientInfoOne: 'Where everyday meets',
                    clientInfoTwo: 'elegance.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/outer-world',
                    clientImgSrc: '/assets/image/clients/outerworld.svg',
                    clientImgAlt: 'Outer World logo',
                    clientInfoOne: `Premium Party Wear`,
                    clientInfoTwo: 'Clothing',
                },
                {
                    clientHref: 'https://www.ameyastore.ae/',
                    clientImgSrc: '/assets/image/clients/ameya.svg',
                    clientImgAlt: 'Ameya logo',
                    clientInfoOne: 'Where Culture meets Couture',
                    target: '_blank',
                },
            ]
        },
        // {
        //     categoryName: "Lifestyle",
        //     clients: [
        //         {
        //             clientHref: '',
        //             clientImgSrc: '',
        //             clientImgAlt: '',
        //         },
        //     ]
        // },
        {
            categoryName: "Sweets",
            clients: [
                {
                    clientHref: '/portfolio/anand-sweets',
                    clientImgSrc: '/assets/image/clients/anand.svg',
                    clientImgAlt: 'Anand Sweets logo',
                    clientInfoOne: `Royal India's Traditional`,
                    clientInfoTwo: 'Sweet Delights.',
                },
                {
                    clientHref: 'https://anandhaassweets.com/',
                    clientImgSrc: '/assets/image/clients/shree-anandhaash.svg',
                    clientImgAlt: 'Shree Anandhaash Sweets & Snacks logo',
                    clientInfoOne: 'Sweets made with tradition.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/radhey-sweets',
                    clientImgSrc: '/assets/image/clients/classicradhey.svg',
                    clientImgAlt: 'Classic Radhey Sweets logo',
                    clientInfoOne: 'Irresistible Indian sweets',
                    clientInfoTwo: 'with authentic flavors',
                },
                {
                    clientHref: '/portfolio/om-sweets',
                    clientImgSrc: '/assets/image/clients/om.svg',
                    clientImgAlt: 'Om Sweets logo',
                    clientInfoOne: 'Traditional sweet treats with',
                    clientInfoTwo: 'casual dining',
                },
                {
                    clientHref: 'https://www.gulabrewri.com/',
                    clientImgSrc: '/assets/image/clients/gulab.svg',
                    clientImgAlt: 'Gulab Sweets logo',
                    clientInfoOne: 'Delicious Indian sweets',
                    clientInfoTwo: 'and snacks',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/gpulla-reddy-sweets',
                    clientImgSrc: '/assets/image/clients/g-pullareddy.svg',
                    clientImgAlt: 'G Pullareddy Sweets logo',
                    clientInfoOne: 'Legacy of pure sweets.',
                },
                {
                    clientHref: '/portfolio/agarwalbhavan-sweets',
                    clientImgSrc: '/assets/image/clients/agarwal.svg',
                    clientImgAlt: 'Agarwal Bhavan Sweets logo',
                    clientInfoOne: 'Crafting authentic Indian',
                    clientInfoTwo: 'sweets with royal taste',
                },
                {
                    clientHref: '/portfolio/singlas-sweets',
                    clientImgSrc: '/assets/image/clients/singlas.svg',
                    clientImgAlt: 'Singlas Sweets logo',
                    clientInfoOne: 'Indian Artisanal Sweets',
                    clientInfoTwo: 'and Treats',
                },
                {
                    clientHref: 'https://prashantcorner.com/',
                    clientImgSrc: '/assets/image/clients/prashant_cornar.svg',
                    clientImgAlt: 'Prashant Corner logo',
                    clientInfoOne: 'Renowned authentic Indian',
                    clientInfoTwo: 'mithai and snacks',
                    target: '_blank',
                },
                {
                    clientHref: 'https://maakhanbhog.com/',
                    clientImgSrc: '/assets/image/clients/maakhanbhog.svg',
                    clientImgAlt: 'Maakhan Bhog logo',
                    clientInfoOne: 'Crafted with purity and love.',
                    target: '_blank',
                },
                {
                    clientHref: 'https://bombaysweets.in/',
                    clientImgSrc: '/assets/image/clients/bombay-sweets.svg',
                    clientImgAlt: 'Bombay Sweets logo',
                    clientInfoOne: 'Creating and delivering',
                    clientInfoTwo: ' premium Indian delicacies',
                    clientClass: 'big_logo_box',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/myoa-cookies',
                    clientImgSrc: '/assets/image/clients/myoa.svg',
                    clientImgAlt: 'Myoa Cookies logo',
                    clientInfoOne: 'Baked for your cravings.',
                },
                {
                    clientHref: 'https://indiasweethouse.in/',
                    clientImgSrc: '/assets/image/clients/india_sweets.svg',
                    clientImgAlt: 'India Sweets logo',
                    clientInfoOne: 'Celebrates sweet flavors',
                    clientInfoTwo: 'through traditional sweets',
                    target: '_blank',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/banchharams.svg',
                    clientImgAlt: 'Banchharams logo',
                    clientInfoOne: 'Kolkata’s sweet tradition.',
                },
                {
                    clientHref: 'https://shop.shreeganga.in/',
                    clientImgSrc: '/assets/image/clients/shreeganga.svg',
                    clientImgAlt: 'Shree Ganga Sweets logo',
                    clientInfoOne: 'Taste of purity and',
                    clientInfoTwo: 'tradition.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/murari-sweets',
                    clientImgSrc: '/assets/image/clients/murari-sweet.svg',
                    clientImgAlt: 'Murari Sweet logo',
                    clientInfoOne: 'Tradition in every bite',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/rasbahar.svg',
                    clientImgAlt: 'Rasbahar logo',
                    clientInfoOne: 'Luxury sweets, perfected.',
                },
                {
                    clientHref: 'https://natuf.in/',
                    clientImgSrc: '/assets/image/clients/natuf.svg',
                    clientImgAlt: 'Natuf logo',
                    clientInfoOne: 'From the heart of the',
                    clientInfoTwo: 'Levant.',
                    target: '_blank',
                },
            ]
        },
        {
            categoryName: "FMCG",
            clients: [
                {
                    clientHref: 'https://www.mtrfoods.com/',
                    clientImgSrc: '/assets/image/clients/mtr.svg',
                    clientImgAlt: 'MTR Foods logo',
                    clientInfoOne: 'Pure spices, real flavour',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/hamdard',
                    clientImgSrc: '/assets/image/clients/hamdard.svg',
                    clientImgAlt: 'Hamdard logo',
                    clientInfoOne: 'Rooh Afza - Drink of',
                    clientInfoTwo: 'the East',
                },
                {
                    clientHref: '/portfolio/chaknow',
                    clientImgSrc: '/assets/image/clients/chaknow.svg',
                    clientImgAlt: 'Chak Now logo',
                    clientInfoOne: 'Crave it. Grab it.',
                },
                {
                    clientHref: '/portfolio/yo-gathiya',
                    clientImgSrc: '/assets/image/clients/yogathiya.svg',
                    clientImgAlt: 'Yo Gathiya logo',
                    clientInfoOne: 'Savory Indian Namkeen',
                    clientInfoTwo: 'Tradition with a Twist',
                },
                {
                    clientHref: '/portfolio/repeat-gud',
                    clientImgSrc: '/assets/image/clients/repeatgud.svg',
                    clientImgAlt: 'Repeat Gud logo',
                    clientInfoOne: 'Healthy, Organic, Plant-Based',
                    clientInfoTwo: 'Food Brand',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/newtrii.svg',
                    clientImgAlt: 'Newtrii logo',
                    clientInfoOne: 'Nutrition that grows',
                    clientInfoTwo: 'with them.',
                },
                {
                    clientHref: '/portfolio/hyfun',
                    clientImgSrc: '/assets/image/clients/hyfun.svg',
                    clientImgAlt: 'HyFun Foods logo',
                    clientInfoOne: 'Premium Frozen Veggie',
                    clientInfoTwo: 'Snacks Collection',
                },
                {
                    clientHref: '/portfolio/fast-n-fry',
                    clientImgSrc: '/assets/image/clients/fastnfry.svg',
                    clientImgAlt: 'Fast N Fry logo',
                    clientInfoOne: 'Premier Supplier of Delicious',
                    clientInfoTwo: 'Frozen Snacks',
                },
                {
                    clientHref: '/portfolio/greenfay',
                    clientImgSrc: '/assets/image/clients/greenfay.svg',
                    clientImgAlt: 'GreenFay logo',
                    clientInfoOne: 'Premium potato farming',
                    clientInfoTwo: 'and processing',
                },
                {
                    clientHref: 'https://zazuandco.com/',
                    clientImgSrc: '/assets/image/clients/zuzu-co.svg',
                    clientImgAlt: 'Zuzu & Co logo',
                    clientInfoOne: 'Nourish them like family.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/yogabar',
                    clientImgSrc: '/assets/image/clients/yogabar.svg',
                    clientImgAlt: 'Yogabar logo',
                    clientInfoOne: 'A Nutrition-led Food',
                    clientInfoTwo: 'Company',
                },
                {
                    clientHref: '/portfolio/ubar',
                    clientImgSrc: '/assets/image/clients/u_bar.svg',
                    clientImgAlt: 'Ubar logo',
                    clientInfoOne: 'Elevating Wellness with',
                    clientInfoTwo: 'Sealth Supplements',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/gogrub',
                    clientImgSrc: '/assets/image/clients/go_grub.svg',
                    clientImgAlt: 'Go Grub logo',
                    clientInfoOne: 'Discover Wholesome',
                    clientInfoTwo: 'Delicious Food Picks',
                },
                {
                    clientHref: '/portfolio/arospice',
                    clientImgSrc: '/assets/image/clients/arospice.svg',
                    clientImgAlt: 'Arospice logo',
                    clientInfoOne: 'Artisanal Indian spices',
                    clientInfoTwo: 'enriching culinary journeys',
                },
            ]
        },
        {
            categoryName: "Tea & Beverages",
            clients: [
                {
                    clientHref: '/portfolio/elder',
                    clientImgSrc: '/assets/image/clients/elder.svg',
                    clientImgAlt: 'Elder logo',
                    clientInfoOne: 'Functional fizz, elevated.',
                },
                {
                    clientHref: '/portfolio/branding/70pc',
                    clientImgSrc: '/assets/image/clients/70pc.svg',
                    clientImgAlt: '70 PC logo',
                    clientInfoOne: 'Stay hydrated, stay sharp.',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/skippi.svg',
                    clientImgAlt: 'Skippi logo',
                    clientInfoOne: 'Freeze the fun.',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/teatox-life',
                    clientImgSrc: '/assets/image/clients/teatox-life.svg',
                    clientImgAlt: 'Teatox Life logo',
                    clientInfoOne: 'Natural Herbal Wellness',
                    clientInfoTwo: 'Teas and Remedies',
                },
                {
                    clientHref: 'https://herbalhermit.com/',
                    clientImgSrc: '/assets/image/clients/herbal-hermit.svg',
                    clientImgAlt: 'Herbal Hermit logo',
                    clientInfoOne: 'Wellness in every cup.',
                    clientClass: 'big_logo_box',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/shistaka',
                    clientImgSrc: '/assets/image/clients/shistaka.svg',
                    clientImgAlt: 'Shistaka logo',
                    clientInfoOne: 'Ayurveda Meets Modern',
                    clientInfoTwo: 'Wellness Wisdom',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/freshleaf',
                    clientImgSrc: '/assets/image/clients/freshleaf.svg',
                    clientImgAlt: 'Freshleaf logo',
                    clientInfoOne: 'Handpicked Teas for',
                    clientInfoTwo: 'Pure Freshness',
                },
                {
                    clientHref: '/portfolio/maison-de-jarin',
                    clientImgSrc: '/assets/image/clients/maison-de-jarin.svg',
                    clientImgAlt: 'Maison de Jarin logo',
                    clientInfoOne: 'The art of herbal indulgence.',
                },
                {
                    clientHref: '/portfolio/label/pourd-cocktails',
                    clientImgSrc: '/assets/image/clients/pourd-coctails.svg',
                    clientImgAlt: 'Pourd Cocktails logo',
                    clientInfoOne: 'Just pour, enjoy more.',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: 'https://compoundcoffee.us/',
                    clientImgSrc: '/assets/image/clients/compound-coffee.svg',
                    clientImgAlt: 'Compound Coffee logo',
                    clientInfoOne: 'Crafted with precision.',
                    target: '_blank',
                },
                {
                    clientHref: '/portfolio/naturare',
                    clientImgSrc: '/assets/image/clients/naturare.svg',
                    clientImgAlt: 'Naturare logo',
                    clientInfoOne: 'Wellness Solutions',
                    clientInfoTwo: 'for Weight Management',
                },
            ]
        },
        {
            categoryName: "Home & Living",
            clients: [
                {
                    clientHref: '/portfolio/ekki-bekki',
                    clientImgSrc: '/assets/image/clients/ekkibekki.svg',
                    clientImgAlt: 'Ekki Bekki logo',
                    clientInfoOne: 'Enduring elegance through',
                    clientInfoTwo: 'sustainable designs',
                },
                {
                    clientHref: '/portfolio/bontrue-furniture',
                    clientImgSrc: '/assets/image/clients/bontrue.svg',
                    clientImgAlt: 'Bontrue Furniture logo',
                    clientInfoOne: 'Crafted for better living.',
                },
                {
                    clientHref: '/portfolio/label/smart-mop',
                    clientImgSrc: '/assets/image/clients/caspian.svg',
                    clientImgAlt: 'Caspian logo',
                    clientInfoOne: `Smart Cleaning`,
                    clientInfoTwo: 'Solutions',
                },
                {
                    clientHref: '/portfolio/neo-roots',
                    clientImgSrc: '/assets/image/clients/neoroots.svg',
                    clientImgAlt: 'Neo Roots logo',
                    clientInfoOne: 'Custom Greenery',
                    clientInfoTwo: 'Design & Execution',
                },
                {
                    clientHref: '/portfolio/tomahawk',
                    clientImgSrc: '/assets/image/clients/tomahawk.svg',
                    clientImgAlt: 'Tomahawk logo',
                    clientInfoOne: `Durable Power Tools`,
                    clientInfoTwo: 'and Hand Tools',
                },
                {
                    clientHref: '/portfolio/wobb-india',
                    clientImgSrc: '/assets/image/clients/wobb-india.svg',
                    clientImgAlt: 'Wobb India logo',
                    clientInfoOne: 'Everyday comfort, redefined.',
                },
                {
                    clientHref: 'https://www.brillenspace.com/',
                    clientImgSrc: '/assets/image/clients/brillen.svg',
                    clientImgAlt: 'Brillen logo',
                    clientInfoOne: 'Designed with purpose.',
                    target: '_blank',
                },
            ]
        },
        {
            categoryName: "Tech Brands",
            clients: [
                {
                    clientHref: '/portfolio/branding/omnes',
                    clientImgSrc: '/assets/image/clients/omnes.svg',
                    clientImgAlt: 'Omnes logo',
                    clientInfoOne: 'Hashrate, on demand.',
                },
                {
                    clientHref: '/portfolio/codifi',
                    clientImgSrc: '/assets/image/clients/codifi.svg',
                    clientImgAlt: 'Codifi logo',
                    clientInfoOne: 'Revolutionizing Indian stock',
                    clientInfoTwo: 'broking solutions',
                },
                {
                    clientHref: '/portfolio/terahash-solutions',
                    clientImgSrc: '/assets/image/clients/terahash.svg',
                    clientImgAlt: 'Terahash logo',
                    clientInfoOne: 'Cryptocurrency Mining',
                    clientInfoTwo: 'Solutions Provider',
                },
                {
                    clientHref: '/portfolio/paperclip-and-co',
                    clientImgSrc: '/assets/image/clients/paperclip.svg',
                    clientImgAlt: 'Paperclip logo',
                    clientInfoOne: 'Social Media',
                    clientInfoTwo: 'Communications Agency',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/fone-network',
                    clientImgSrc: '/assets/image/clients/fonnetwork.svg',
                    clientImgAlt: 'Fone Network logo',
                    clientInfoOne: 'Mobile Blockchain',
                    clientInfoTwo: 'and Cryptocurrency',
                },
                {
                    clientHref: 'https://parfaittu.com/home',
                    clientImgSrc: '/assets/image/clients/parfaittu.svg',
                    clientImgAlt: 'Parfaittu logo',
                    clientInfoOne: 'Personal Development',
                    clientInfoTwo: 'Growth for Teens',
                    target: '_blank',
                },
            ]
        },
        {
            categoryName: "Other Brands",
            clients: [
                {
                    clientHref: '#',
                    clientImgSrc: '/assets/image/clients/orange-motions.svg',
                    clientImgAlt: 'Orange Motions logo',
                    clientInfoOne: 'Smarter ways to move',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: '/portfolio/instant-cash-price',
                    clientImgSrc: '/assets/image/clients/instant-cash-price.svg',
                    clientImgAlt: 'Instant Cash Price logo',
                    clientInfoOne: 'Get cash for your car,',
                    clientInfoTwo: 'fast.',
                },
                {
                    clientHref: '/portfolio/dl-films',
                    clientImgSrc: '/assets/image/clients/dlfilms.svg',
                    clientImgAlt: 'DL Films logo',
                    clientInfoOne: 'Life Explored: Photography',
                    clientInfoTwo: 'Experts',
                },
                {
                    clientHref: '/portfolio/aurolab',
                    clientImgSrc: '/assets/image/clients/aurolab.svg',
                    clientImgAlt: 'Aurolab logo',
                    clientInfoOne: 'Visionary Ophthalmic',
                    clientInfoTwo: 'Solutions Worldwide',
                },
                {
                    clientHref: '/portfolio/sinclairs-hotels',
                    clientImgSrc: '/assets/image/clients/sinclairs.svg',
                    clientImgAlt: 'Sinclairs Hotels & Resorts logo',
                    clientInfoOne: 'Where legacy meets comfort.',
                },
                {
                    clientHref: '/portfolio/mom-3.0',
                    clientImgSrc: '/assets/image/clients/mom.svg',
                    clientImgAlt: 'MOM logo',
                    clientInfoOne: 'Care for you and your',
                    clientInfoTwo: 'little one.',
                    clientClass: 'big_logo_box',
                },
                {
                    clientHref: 'https://uquid.com/',
                    clientImgSrc: '/assets/image/clients/uquid.svg',
                    clientImgAlt: 'Uquid logo',
                    clientInfoOne: 'Crypto payments, simplified.',
                    target: '_blank',
                },
            ]
        },
];

function ClientsCard({ clientHref, target, clientImgSrc, clientImgAlt, clientClass, clientInfoOne, clientInfoTwo, buttonClass }) {
    const isInternal = clientHref && clientHref.startsWith('/') && target !== '_blank';

    const cardContent = (
        <div className="product_logo client_div">
            <div className={"logo_box " + (clientClass || '')}>
                <img src={clientImgSrc} loading="lazy" alt={clientImgAlt} />
            </div>
            <p>{clientInfoOne} <br className="d-lg-block d-none" /> {clientInfoTwo}</p>
            <div className={"logos_link " + (buttonClass || '')}>
                <span className="discover_span">DISCOVER</span>
                <span className="logo_span">
                    <DiscoverArrow />
                </span>
            </div>
        </div>
    );

    if (isInternal) {
        return (
            <Link to={clientHref} className="image_color bg-white">
                {cardContent}
            </Link>
        );
    }

    return (
        <a
            href={clientHref || '#'}
            target={target}
            {...(target === '_blank' ? { rel: 'noopener noreferrer' } : {})}
            className="image_color bg-white"
        >
            {cardContent}
        </a>
    );
}

export default function Clients() {
    return (
        <>
            <Helmet>
                <title>Our Clients | Work Stories and Collaborations | Abox Agency</title>
                <meta name="title" content="Our Clients | Work Stories and Collaborations | Abox Agency" />
                <meta name="description" content="Explore the success stories and collaborations with our valued clients. Discover how Abox Agency has empowered businesses to thrive in the digital landscape through tailored solutions and creative partnerships." />
                <meta name="keywords" content="Abox, Shopify, E-commerce, Web Agency, Web Development, Shopify store, A/B, Our Clients, Client Success Stories, Collaborations, Valued Partnerships, Business Empowerment, Creative Solutions, Tailored Services, Digital Success, Client Showcase, Client Testimonials, Business Growth, Web Agency Collaborations, Client-Centric Solutions, Digital Transformation, Success in Collaboration, Empowering Brands, Client Portfolio, Innovative Partnerships, Web Agency Clients, Creative Excellence, Business Transformation Stories, Partnering for Success, Client-Centered Approach, Web Agency Success, Empowered Businesses" />
                <link rel="canonical" href="https://abox.agency/clients" />
                <script type="application/ld+json">{stringifySchema(clientsSchema)}</script>
            </Helmet>

            <Header />

            {/* hero section */}
            <section className="header_padding">
                <div className="section_detail clients-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-7 col-xl-7 col-md-10">
                                <p className="font_medium">©2026</p>
                                <h1 className="contact_title">Branding and web design studio, driven by strategy & innovation. <br className="d-md-none d-block" /> <Link to="/contact" className="shadow_btn">Work with us</Link></h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* clients section */}
            <section className="section_detail client_section pt-0">
                {clientCategories.map((cat, catIndex) => (
                    <div key={catIndex} >
                        <div className="product_category">
                            <h2 className="client_section_title mb-0">{cat.categoryName}</h2>
                        </div>
                        <div className="container">
                            <div className="product_section">
                                {cat.clients.map((client, index) => (
                                    <ClientsCard key={index} {...client} />
                                ))}
                            </div>
                        </div>
                    </div>
                ))}
            </section>

            <LetsTalk />

            <Footer />
        </>
    );
}